import React, { useContext } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { FaRegUser } from "react-icons/fa6";
import { CiShop } from "react-icons/ci";
import { SlLike, SlSettings } from "react-icons/sl";
import { GoMail } from "react-icons/go";
import { LuView } from "react-icons/lu";
import { MdOutlineRateReview } from "react-icons/md";
import { FaRegAddressCard } from "react-icons/fa";
import { AuthContext } from "../../../Context/AuthContext";
import { ACCOUNT, MARKET } from "../libs/marketplaceRoutes";
import "./UserProfile.css";

const NAV_ITEMS = [
  { to: ACCOUNT.HOME, icon: FaRegUser, label: "My Stex Profile", end: true },
  { to: ACCOUNT.ORDERS, icon: CiShop, label: "Orders" },
  { to: ACCOUNT.SAVED, icon: SlLike, label: "Saved items" },
  { to: ACCOUNT.INBOX, icon: GoMail, label: "Inbox" },
  { to: ACCOUNT.RECENT, icon: LuView, label: "Recently Viewed" },
  { to: ACCOUNT.REVIEWS, icon: MdOutlineRateReview, label: "Pending Evaluation" },
  { to: ACCOUNT.ADDRESSES, icon: FaRegAddressCard, label: "Address Book" },
  { to: ACCOUNT.SETTINGS, icon: SlSettings, label: "Settings" },
];

const Usernavbar = () => {
  const { Logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isNavActive = (to) => pathname === to;

  const handleLogOut = () => {
    Logout();
    navigate(MARKET.HOME);
  };

  return (
    <aside className="account-sidebar">
      <p className="account-sidebar__label">My account</p>
      <nav className="account-sidebar__nav">
        {NAV_ITEMS.map(({ to, icon: Icon, label, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={() =>
              `account-sidebar__link${isNavActive(to) ? " account-sidebar__link--active" : ""}`
            }
          >
            <Icon aria-hidden="true" />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
      <button type="button" className="account-sidebar__logout" onClick={handleLogOut}>
        Logout
      </button>
    </aside>
  );
};

export default Usernavbar;
